var GradingBy = {
  ASSESSMENT_GRADING_METHOD_AVERAGE: 'Average Score',
  ASSESSMENT_GRADING_METHOD_HIGHEST: 'Highest Score',
  ASSESSMENT_GRADING_METHOD_LATEST: 'Latest Score'
};
var ASSESSMENT_STATES = {
  ASSESSMENT_STATE_DRAFT: {
    label: 'Draft'
  },
  ASSESSMENT_STATE_SUBMITTED: {
    label: 'Submitted'
  },
  ASSESSMENT_STATE_STARTED: {
    label: 'Started'
  },
  ASSESSMENT_STATE_FINISHED: {
    label: 'Completed'
  },
  ASSESSMENT_STATE_CANCELED: {
    label: 'Cancelled'
  }
};
var STUDENT_STATES = {
  ASSESSMENT_STATE_STARTED: {
    label: 'Available/Started'
  },
  ASSESSMENT_STATE_FINISHED: {
    label: 'Completed/Missed'
  }
};
var routeToType = {
  quiz: 'ASSESSMENTS_TYPE_QUIZ',
  assignment: 'ASSESSMENTS_TYPE_ASSIGNMENT'
};
var TYPE_HOMEWORKS = {
  HOMEWORK: '@assessments/type/homework'
};
export default {
  GradingBy: GradingBy,
  ASSESSMENT_STATES: ASSESSMENT_STATES,
  STUDENT_STATES: STUDENT_STATES,
  routeToType: routeToType,
  TYPE_HOMEWORKS: TYPE_HOMEWORKS
};